
import { EmployeeFilterComponent } from './employee/employees.component';




export const FilterComponents = [
    EmployeeFilterComponent
]